import { render, staticRenderFns } from "./jy-receiptGoods.vue?vue&type=template&id=2c89ac6e&scoped=true&"
import script from "./jy-receiptGoods.vue?vue&type=script&lang=js&"
export * from "./jy-receiptGoods.vue?vue&type=script&lang=js&"
import style0 from "./jy-receiptGoods.vue?vue&type=style&index=0&id=2c89ac6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89ac6e",
  null
  
)

export default component.exports